const initialState = {
  newDamages: [],
};
export default initialState;
